
import API from "../../API/api";

export const GettingProblemByReferenceCode = async (referenceCode,messageData) => {
  try {
    const response = await API.get(
      `/problems/ref/${referenceCode}`,
      messageData
    );
    return {found : true, Problem : response.data};
  }  catch (err) {
    if (err.response && err.response.status === 404) {
      // Friendly handling for not found
      return {status: 404, found: false, message: "Sorry, problem not found on the website." };
    }
    console.error("Error fetching problem:", err);
    throw err; // other errors still bubble up
  }
};


export const EditingProblemByReferenceCode = async (referenceCode,messageData) => {
  try {
    const response = await API.put(
      `/problems/ref/${referenceCode}`,
      messageData
    );
    return {found : true, Problem : response.data};
  }  catch (err) {
    if (err.response && err.response.status === 404) {
      // Friendly handling for not found
      return {status: 404, found: false, message: "Sorry, problem not found on the website." };
    }
    console.error("Error fetching problem:", err);
    throw err; // other errors still bubble up
  }
};


export const DeletingProblemByReferenceCode = async (referenceCode,messageData) => {
  try {
    const response = await API.delete(
      `/problems/ref/${referenceCode}`,
      messageData
    );
    return {found : true, message : "Deleted successfully"};
  }  catch (err) {
    if (err.response && err.response.status === 404) {
      // Friendly handling for not found
      return {status: 404, found: false, message: "Sorry, problem not found on the website." };
    }
    console.error("Error fetching problem:", err);
    throw err; // other errors still bubble up
  }
};


export const deleteSolution = async (referenceCode,index) => {
  try {
    await API.delete(`/problems/ref/${referenceCode}/solution/${index}`);
  return {found : true, message : "Deleted successfully"};
  }  catch (err) {
    if (err.response && err.response.status === 404) {
      // Friendly handling for not found
      return {status: 404, found: false, message: "Sorry, problem not found on the website." };
    }
    console.error("Error fetching problem:", err);
    throw err; // other errors still bubble up
  }
};